module.exports = __webpack_public_path__ + "img/print_received.9cb3856c.png";